import React from "react";
import { Chart } from "react-google-charts";

const options = {
  sankey: {
    link: { colorMode: "gradient" },
    node: {
      colors: ["#00ccff", "#00ffcc", "#ffff00", "#ff00cc", "#cc00ff"],
      label: { color: "#fff", fontSize: 12 },
      interactivity: true,
      width: 20,
      colorMode: "unique",
    },
    tooltip: { isHtml: true },
  },
};

const rawOptions = {
  sankey: {
    link: {
      colorMode: "none",
    },
    node: {
      label: {
        fontSize: 12,
        color: "#fff",
        bold: true,
      },
      interactivity: true,
      width: 20,
      colors: ["#fff"],
    },
    tooltip: { isHtml: true },
  },
};

function SankeyChart({ data, raw }) {
  if (raw)
    return (
      <Chart
        chartType="Sankey"
        width="100%"
        height="300px"
        data={data}
        options={rawOptions}
      />
    );
  return (
    <Chart
      chartType="Sankey"
      width="100%"
      height="300px"
      data={data}
      options={options}
    />
  );
}

export default SankeyChart;
